import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import useLink from "@qpr/client-api-base/hooks/useLink";
import PeriodSelector from "components/PeriodSelector";
import ToolbarTitle from "design/components/texts/ToolbarTitle";
import Tabs from "design/components/toolbar/Tabs";
import ToolbarContainer from "design/components/toolbar/ToolbarContainer";
import Center from "design/layouts/Center";
import Right from "design/layouts/Right";
import SplitView from "design/layouts/SplitView";
import React from "react";

type Props = { selected?: string };

const WorkflowToolbar = (props: Props) => {
  const ctx = useAppContext();
  const link = useLink();

  return (
    <ToolbarContainer>
      <SplitView partCnt={3}>
        <ToolbarTitle>
          {ctx.page === "mytasks"
            ? "My Tasks"
            : ctx.page === "workflowinput"
            ? "Value Input"
            : "Completed Tasks"}
        </ToolbarTitle>
        <Center>
          <Tabs
            onChange={(value) => {
              link({
                page: value,
              });
            }}
            selected={props.selected || ctx.page || ""}
            options={[
              {
                viewName: "mytasks",
                title: "My Tasks",
              },
              {
                viewName: "workflowinput",
                title: "Actions",
              },
              {
                viewName: "completedtasks",
                title: "Completed Tasks",
              },
            ]}
          />
        </Center>
      </SplitView>
    </ToolbarContainer>
  );
};

export default WorkflowToolbar;
